import {
  Action,
  FormHandlers,
  Portal, useModal,
} from '@doveit/bricks';
import React from 'react';
import SimpleModal from '../../../components/simple-modal/SimpleModal';
import { Agency } from '../../../providers/api/dtos';
import UpdateAgencyTeam from '../update-agency-team/UpdateAgencyTeam';

type ChildFnProps = {
  updateAgencyTeam: VoidFunction,
};

export interface UpdateAgencyTeamActionProps {
  agency: Agency,
  children?: (props: ChildFnProps) => React.ReactNode,
  onSuccess?: (agency: Agency) => void,
}

const UpdateAgencyTeamAction: React.FC<UpdateAgencyTeamActionProps> = ({
  agency,
  children,
  onSuccess,
}) => {
  const formRef = React.useRef(null) as any as React.MutableRefObject<FormHandlers>;

  const modal = useModal();

  const handleSuccess = React.useCallback((updatedAgency: Agency) => {
    modal.close();
    onSuccess?.(updatedAgency);
  }, [modal, onSuccess]);

  return (
    <>
      {children
        ? children({
          updateAgencyTeam: modal.open,
        })
        : (
          <Action
            label="Modifica team"
            aria-label="Pulsante per modificare il team dell'agenzia"
            size="S"
            onClick={() => modal.open()}
          />
        )}
      <Portal>
        <SimpleModal
          {...modal}
          aria-label="Modale per modificare il team dell'agenzia"
          title="Modifica team"
          footer={(
            <Action
              label="Modifica"
              color="primary"
              emphasis="high"
              aria-label="Pulsante per salvare il team dell'agenzia"
              onClick={() => formRef.current?.handleSubmit()}
            />
          )}
        >
          <UpdateAgencyTeam
            agency={agency}
            formRef={formRef}
            onSuccess={handleSuccess}
          />
        </SimpleModal>
      </Portal>
    </>
  );
};

export default UpdateAgencyTeamAction;
